import { INormalizedGame } from '../../types';

export const getGames = (
  gamesIds: string[] = [],
  games: Record<string, INormalizedGame> = {}
) => gamesIds.map((id) => games[id]).filter(Boolean);
